import PropTypes from 'prop-types';
import React from 'react';
import { SubmissionError } from 'redux-form';
import Layout from '../../../components/Layout';
import Profile from './Profile';
import ProfileForm from './ProfileForm';
import PasswordForm from './PasswordForm';
import diff from 'object-diff';
import { Modal, FormGroup, Button, ButtonToolbar, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import Dropzone from 'react-dropzone';
import Avatar from 'react-avatar';


const stringValues = {
  "is_responded": "Responded",
  "is_accepted": "Accepted",
  "is_declined": "Declined"
}

class ProfileLayout extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.state = {
      showConfirm: false,
      showConfirmBidReminder: false,
      confirmModalValues: {},
      modalBodyText: '',
      modalBodyTextBidReminder: ''
    }
  }
  componentWillMount() {
    const profile = JSON.parse(sessionStorage.getItem('auth'));
    if (this.props.needFetch) {
      this.props.requestProfile(profile.profile.user.id);
    }
  }
  handleSubmit(values) {
    if (values.password !== values.password2) {
      throw new SubmissionError({
        password2: 'Passwords do not match',
        _error: 'Password fields do not match',
      });
    }
    return this.props.setPassword(this.props.profile.user.id, values);
  }
  handleEdit(values) {
    const changedValues = diff(this.props.profile, values);
    return this.props.editProfile(this.props.profile.user.id, changedValues);
  }

  onCheckBoxClicked = (type) => {
    let modalBodyText = ''
    if (this.props.profile[type]) {
      modalBodyText = `You won’t receive any email of ${stringValues[type]} Bids until you turn them on.`
    }
    else {
      modalBodyText = `You will receive all emails of ${stringValues[type]} Bids until you turn them off.`
    }

    this.setState({
      showConfirm: true,
      confirmModalValues: {
        [type]: !this.props.profile[type]
      },
      modalBodyText: modalBodyText
    })


  }

  onBidSettingEdit = (type) => {
    let modalBodyTextBidReminder = ''
    if (this.props.profile[type]) {
      modalBodyTextBidReminder = `Bid reminder mails won’t sent until you turn them on.`
    }

    this.setState({
      showConfirmBidReminder: true,
      confirmModalValues: {
        [type]: !this.props.profile[type]
      },
      modalBodyTextBidReminder: modalBodyTextBidReminder
    })


  }

  closeModalPopup = () => {
    this.setState({
      showConfirm: false
    })
  }
  
  closeBidReminderModalPopup = () => {
    this.setState({
      showConfirmBidReminder: false
    })
  }

  setEmailPreference = () => {
    this.props.editProfile(this.props.profile.user.id, this.state.confirmModalValues);
    this.setState({
      showConfirm: false,
      confirmModalValues: {
      },
      modalBodyText: ''
    })

  }

  setBidReminderSetting = () => {
    this.props.editProfile(this.props.profile.user.id, this.state.confirmModalValues);
    this.setState({
      showConfirmBidReminder: false,
      confirmModalValues: {
      },
      modalBodyText: ''
    })

  }

  onDaySelect = (e, type) => {
    const dayValue = e.target.value;
    let modalBodyTextBidReminder = ''
    if (type == "is_send_bid_reminder") {
      modalBodyTextBidReminder = `Bid reminder mails won’t sent until you turn them on.`
    }else if(type == "send_after_days") {
      modalBodyTextBidReminder = `Bid reminder mails will sent after every ${dayValue} day(s)`
    }else {
      modalBodyTextBidReminder = `Bid reminder mails will sent ${dayValue} times`
    }

    this.setState({
      showConfirmBidReminder: true,
      confirmModalValues: {
        [type]: dayValue
      },
      modalBodyTextBidReminder: modalBodyTextBidReminder
    })
  }

  getDayOptions = (selectField) => {
    let options = []
    let i=1;
    if(selectField == "send_after_days"){
      for(i;i<11;i++){
        options.push(<option value={i}>{i}</option>)
      }
    }else{
      for(i;i<5;i++){
        options.push(<option value={i}>{i}</option>)
      }
    }
    return options
  }

  render() {
    if (this.props.isFetching || this.props.needFetch) {
      return (
        <Layout>
          <div className="planner col-sm-12">
            <p className="text-center">
              <i className="fa fa-spinner fa-spin fa-3x fa-fw" />
              <span className="sr-only">Loading...</span>
            </p>
          </div>
        </Layout>
      );
    }
    if (this.props.action === 'password') {
      return (
        <Layout>
          <div className="container-fluid">
            <div>
              <h2>
                {this.props.profile.user.first_name} {this.props.profile.user.last_name}
              </h2>
              <h2>{this.props.profile.title}</h2>
              <p>
                <i className="fa fa-envelope-o" /> {this.props.profile.user.email}
              </p>
              <hr/><br/>
            </div>
            <div className="row">
              <div className="col-sm-12 planner">
                <PasswordForm
                  profile={this.props.profile}
                  onSubmit={this.handleSubmit}
                  onClose={this.props.gotoProfile}
                />
              </div>
            </div>
          </div>
        </Layout>
      );
    }
    if (this.props.action === 'edit') {
      return (
        <Layout>
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12  planner">
                <ProfileForm
                  initialValues={this.props.profile}
                  onSubmit={this.handleEdit}
                  onClose={this.props.gotoProfile}
                />
              </div>
            </div>
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <div className="container-fluid">
          <div className="row">
            <div className="planner col-sm-12">
              <Profile
                profile={this.props.profile}
                gotoProfileEdit={this.props.gotoProfileEdit}
                gotoProfilePassword={this.props.gotoProfilePassword}
                editProfileImage={this.props.editProfileImage}
              />
            </div>
          </div>
          {this.props.perms.includes('travel_management') &&
            (<div className="row">
              <div className="planner col-sm-12">
                <div>
                  <h2>
                    Email Preferences
                </h2>
                  <p>
                    Bid Request Emails
                </p>
                </div>

                <div className="tour-todo">
                  <ul>
                    <li>
                      <input type="checkbox" checked={this.props.profile.is_responded} onClick={() => this.onCheckBoxClicked("is_responded")} />
                      Responded
                  </li>
                    <li>
                      <input type="checkbox" checked={this.props.profile.is_declined} onClick={() => this.onCheckBoxClicked("is_declined")} />
                      Declined
                  </li>
                  <div className="bid-reminder-section">
                  <h2>
                    Bid Reminder Setting
                  </h2>
                  <li>
                     <input type="checkbox" checked={this.props.profile.is_send_bid_reminder} onClick={() => this.onBidSettingEdit("is_send_bid_reminder")} />
                     Send Bid Reminder Emails(In case the hotel has already replied, the bid reminder mail will not be sent)
                  </li>
                  <li>
                     <p>Send every &nbsp;
                        <select onChange={(e) => this.onDaySelect(e, "send_after_days")} value={this.props.profile.send_after_days}>
                          {this.getDayOptions("send_after_days")}
                         
                        </select>
                        &nbsp;
                        days
                      </p>
                  </li>
                  <li>
                     <p>Send reminder &nbsp;
                     <select onChange={(e) => this.onDaySelect(e, "send_reminder_times")} value={this.props.profile.send_reminder_times}>
                        {this.getDayOptions("send_reminder_times")}
                        
                     </select>
                     &nbsp;
                      times</p>
                  </li>
                  </div>
                  </ul>
                  {this.state.showConfirm && (
                    <Modal show={this.state.showConfirm}>
                      <Modal.Header>
                        <Modal.Title>Confirm Email Preference Update</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p> Are you sure you want to change email Preferences?</p>
                        <p> {this.state.modalBodyText}  </p>

                        <ButtonToolbar style={{ float: "right" }}>
                          <Button
                            bsStyle="success"
                            onClick={this.setEmailPreference}
                          >
                            Confirm
                          </Button>
                          <Button
                            bsStyle="success"
                            onClick={this.closeModalPopup}
                          >
                            Cancel
                          </Button>
                        </ButtonToolbar>
                      </Modal.Body>
                      <Modal.Footer style={{ clear: "both" }} />
                    </Modal>
                  )}
                  {this.state.showConfirmBidReminder && (
                    <Modal show={this.state.showConfirmBidReminder}>
                      <Modal.Header>
                        <Modal.Title>Confirm Bid Reminder Setting</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <p> Are you sure you want to change bid reminder setting?</p>
                        <p> {this.state.modalBodyTextBidReminder}  </p>

                        <ButtonToolbar style={{ float: "right" }}>
                          <Button
                            bsStyle="success"
                            onClick={this.setBidReminderSetting}
                          >
                            Confirm
                          </Button>
                          <Button
                            bsStyle="success"
                            onClick={this.closeBidReminderModalPopup}
                          >
                            Cancel
                          </Button>
                        </ButtonToolbar>
                      </Modal.Body>
                      <Modal.Footer style={{ clear: "both" }} />
                    </Modal>
                  )}
                </div>
              </div>
            </div>
            )
          }
        </div>
      </Layout>
    );
  }
}

ProfileLayout.propTypes = {
  profile: PropTypes.shape({
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
    mobile: PropTypes.string,
    office: PropTypes.string,
    title: PropTypes.string,
    custom_image: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  action: PropTypes.string.isRequired,
  needFetch: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  requestProfile: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  gotoProfile: PropTypes.func.isRequired,
};
ProfileLayout.defaultProps = {
  profile: {
    id: null,
  },
};

export default ProfileLayout;



// WEBPACK FOOTER //
// src/routes/profile/components/ProfileLayout.js